export class PDFOptions {
    page : number = 1;
    rotation : number = 0;
    zoom : number = 1;
    fitToPage : boolean = true;
    originalSize: boolean = true;
}
